import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import RightArrowIcon from '../../../../assets/icons/ArrowRight.svg';
import CheckmarkIcon from '../../../../assets/icons/Checkmark.svg';

import { Text, ConfigCard, Spacer } from '../../../../shared/components';
import IconCircle from '../IconCircle';

export default function ConfigurationStatusCard({
  icon,
  title,
  subtitle,
  completed,
  clickCb,
}) {
  return (
    <div
      onClick={
        clickCb ? clickCb : () => console.log('Click ConfigurationStatusCard')
      }
      style={{
        cursor: 'pointer',
        maxHeight: '150px',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <ConfigCard justifyContent="space-between" alignItems="center">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconCircle
            icon={
              <SVG src={icon} width={23} color="var(--color-blue-primary)" />
            }
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              marginLeft: '20px',
            }}
          >
            <Text.h4>{title}</Text.h4>
            <Spacer.vertical size={10} />
            <Text.small weak>{subtitle}</Text.small>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {completed ? (
            <SVG src={CheckmarkIcon} width={30} color="#00D027" />
          ) : (
            <SVG src={RightArrowIcon} width={35} color="#3A3A3A" />
          )}
        </div>
      </ConfigCard>
    </div>
  );
}

ConfigurationStatusCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  completed: PropTypes.bool.isRequired,
  clickCb: PropTypes.func,
};
